import type { GoogleNexusRefreshResult, GoogleNexusUpload } from '../../domain/nexus/model';
import { isPollableNexusUpload } from '../AdminPage/tools/GoogleNexusTool/helpers';

/** Merges a `refreshUpload` result into the loaded record. */
export function applyRefreshResult(
  upload: GoogleNexusUpload,
  result: GoogleNexusRefreshResult,
  polledAt: string,
): GoogleNexusUpload {
  if (!result.ok) {
    return { ...upload, lastPollError: result.error ?? null, lastPolledAt: polledAt };
  }
  return {
    ...upload,
    status: result.status ?? upload.status,
    remoteResponse: result.response,
    lastPollError: null,
    lastPolledAt: polledAt,
  };
}

export function shouldPollUpload(upload: GoogleNexusUpload | null): boolean {
  return isPollableNexusUpload(upload);
}
